import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const breakfastsCountColumn = <T extends { breakfastsCount: number }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('Breakfasts count'),
    dataIndex: 'breakfastsCount',
  });
